import axios from 'axios'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import {
  CarDestinationOutPutDTO,
  TransferDestinationOutPutDTO,
  HotelDestinationOutPutDTO,
  FlightDestinationOutPutDTO,
} from 'src/services/external/destinationDTO'

class DestinationsServices {
  async getDestinationCarByName(name: string): Promise<CarDestinationOutPutDTO[]> {
    try {
      const res = await axios.get(`https://api-autocomplete.tije.travel/autocomplete/search`, {
        headers: { 'Content-Type': 'application/json' },
        params: {
          _format: 'json',
          flow_code: 'rentingcarz',
          product: 'rentingcarz',
          locale: 'es_AR',
          query: name,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinationTransferByName(name: string): Promise<TransferDestinationOutPutDTO[]> {
    try {
      const res = await axios.get(`https://api-autocomplete.tije.travel/autocomplete/search`, {
        headers: { 'Content-Type': 'application/json' },
        params: {
          _format: 'json',
          flow_code: 'transfer',
          product: 'transfer',
          locale: 'es_AR',
          query: name,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinationHotelByName(name: string): Promise<HotelDestinationOutPutDTO[]> {
    try {
      const res = await axios.get(`https://api-autocomplete.tije.travel/autocomplete/search`, {
        headers: { 'Content-Type': 'application/json' },
        params: {
          _format: 'json',
          flow_code: 'hotel_gimmonix',
          product: 'hotel_gimmonix',
          locale: 'es_AR',
          query: name,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinationFlightByName(name: string): Promise<FlightDestinationOutPutDTO[]> {
    try {
      const res = await axios.get(`https://api-autocomplete.tije.travel/autocomplete/search`, {
        headers: { 'Content-Type': 'application/json' },
        params: {
          _format: 'json',
          flow_code: 'flight',
          product: 'flight',
          locale: 'es_AR',
          query: name,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const destinationsServices = new DestinationsServices()
